import React from "react";
import ReactDOM from "react-dom";
import "@hookstate/devtools";
import CssBaseline from "theme/Baseline";
import { ThemeProvider } from "styled-components";
import defaultTheme, { Typography } from "theme/Default";

import App from "./App";

ReactDOM.render(
  <React.StrictMode>    
    <CssBaseline Typography={Typography} />
    <ThemeProvider theme={defaultTheme}>
      <App />      
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
